<template>
  <SpecialtyServices />
</template>

<script>
import SpecialtyServices from '../components/sections/SpecialtyServices.vue'

export default {
  name: 'ServicesPage',
  components: {
    SpecialtyServices
  }
}
</script>
